// extracted by mini-css-extract-plugin
export default {"productCardGreen":"productCard_productCardGreen__3iBPC","productCardRed":"productCard_productCardRed__FpUMX","productCardYellow":"productCard_productCardYellow__ot6ev"};